import register from '../register';
import dom from './util/dom';
import {
  validateEmail,
  validatePhone,
  addError,
  removeError,
  isEmpty,
  isNotSubmit,
  shouldValidate
} from './util/form-utils';

let $ = document.querySelector.bind( document );

let $form;
let $submit;
let $formBody;
let $error;
let $inputs;
let $_id;
let $notServiceableThanks = $('.thanks.not-serviceable');
let $signupAvailable = $('.check-serviceability__signup-available');
let $waitlistAvailable = $('.check-serviceability__waitlist-available');
let $managementForm = $('.management-form');
let $confirmation = $('.thanks.is-serviceable');
let $component = $('.check-avail-petition-component');

let validators = {
  email: validateEmail,
  phone: validatePhone
};

function init() {
  $form = $('#serviceable-form');
  $submit = $('#inp-submit');
  $formBody = $('.form-body');
  $error = $('.serviceable__submit-error');
  $inputs = [ ...$form.querySelectorAll('input:not([type="radio"]), select') ];
  $_id = $('#inp-waitlist-id');

  $form.addEventListener( 'submit', onSubmit );
}

function showSignup() {
  $formBody.style.display = 'none';
  const btn = $('.check-serviceability__signup-btn');
  const place_id = $('input[name="place_id"').value;
  btn.href = `${ window.signup_url }/signup/${ place_id }`;
  $signupAvailable.style.display = 'block';
}

function showWaitlist() {
  $formBody.style.display = 'none';
  $waitlistAvailable.style.display = 'block';
}

function showManagementForm() {
  $formBody.style.display = 'none';
  $managementForm.style.display = 'block';
}

function showNotServiceable() {
  $formBody.style.display = 'none';
  $notServiceableThanks.style.display = 'block';
}

function onSubmit( e ) {
  e.preventDefault();

  let payload;

  if ( validate() ) {
    payload = getPayload();
    if ( !payload.flow ) {
      $component.classList.add('required-error');
      return;
    }

    $submit.disabled = true;
    $submit.classList.add('loading');

    acumen.track( 'web-submit-petition', { flow: payload.flow } );

    if ( payload.flow === 'signup' ) {
      showSignup();
      return;
    }

    submitForm( payload );
  }
}

function submitForm( payload ) {
  dom.ajax(
    {
      url: '/serviceable',
      method: 'POST'
    },
    payload,
    ( err, res ) => {
      if ( err ) {
        onError();
        return;
      }

      onSuccess( res );
    }
  );
}

function onError() {
  $error.classList.remove('hidden');
  $submit.disabled = false;
  $submit.classList.remove('loading');
}

function onSuccess( res ) {
  const flow = $('input[name="flow"]').value;
  const in_market = $('input[name="in_market"]').value;
  let waitlistId = res._id;

  if ( waitlistId ) {
    $_id.value = waitlistId;
  }

  if ( flow === 'waitlist' ) {
    showWaitlist();
    return;
  }

  if ( flow === 'serviceable' ) {
    showManagementForm();
    return;
  }

  if ( in_market === 'true' ) {
    $managementForm.classList.add('in-market');
    $confirmation.classList.add('in-market');
    showManagementForm();
    return;
  }

  showNotServiceable();
  return;
}

function isInvalid( inp ) {
  let validate = validators[ inp.dataset.validate ];
  return typeof validate === 'function' ?
    !validate( inp.value ) : isEmpty( inp );
}

function inputReducer( obj, inp ) {
  obj[ inp.name ] = inp.type === 'checkbox' ?
    inp.checked : ( inp.value || null );
  return obj;
}

function validate() {
  return !$inputs
  .filter( shouldValidate )
  .map( removeError )
  .filter( isInvalid )
  .map( addError ).length;
}

function getPayload() {
  return $inputs
  .filter( isNotSubmit )
  .reduce( inputReducer, {} );
}

register( 'petition-landing-form', init );

export default undefined;
